/* @flow */
import React from 'react';
import Box from 'components/Box.jsx';
import BoxBody from 'components/BoxBody.jsx';
import CenteredContainer from 'components/CenteredContainer.jsx';
import Columns2 from 'components/Columns2.jsx';
import DialogTitle from 'components/DialogTitle.jsx';
import Group from 'entities/Group';
import GroupName from 'groups/components/GroupName.jsx';
import JoinGroupFormPanel from './JoinGroupFormPanel.jsx';
import JoinGroupAvatarPanel from './JoinGroupAvatarPanel.jsx';
import Text from 'components/Text.jsx';

import './styles/JoinGroupPage.scss';

const JoinGroupPage = React.createClass({
  propTypes: {
    groupJson: React.PropTypes.object.isRequired,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  statics: {
    loadProps(renderProps, cb) {
      const { groupCode } = renderProps.params;
      const { router } = renderProps.loadContext;

      const cleanGroupCode = Group.parseAcceptableGroupCode(groupCode);

      if (cleanGroupCode) {
        Group
          .fetchByCode(cleanGroupCode)
          .then((group) => {
            if (group.canJoin()) {
              // convert to JSON because that's how it will be serialized
              cb(null, { groupJson: group.toJSON() });
            } else {
              console.error('DEBUG loadProps cannot join');
              router.replace('/error');
              cb(new Error('Cannot join group'));
            }
          },
          err => {
            console.error('DEBUG loadProps', err);
            router.replace(`/join?notFound=${groupCode}`);
            cb(err);
          }
        );
      } else {
        router.replace(`/join?notFound=${groupCode}`);
        cb('invalid group code', groupCode);
      }
    },
  },

  render() {
    const { groupJson } = this.props;

    // reconstructing on render isn't ideal, but this shouldn't rerender and
    // we need to think through a good solution for serializing models
    const group = Group.fromJSON(groupJson);

    // XXX - This is to fix https://my.trackjs.com/details/9a7be15d01bd4ae98c41d04c4148a8aa.
    // Somehow we're ending up with an empty groupJson here sometimes
    if (!group.id) {
      console.warn('Trying to render an empty group');
      return null;
    }

    return (
      <CenteredContainer size="large">
        <Box>
          <BoxBody>
            <Columns2 reset="tablet" flex>
              <div>
                <JoinGroupAvatarPanel group={group} className="JoinGroupPage-header" />
                <DialogTitle className="JoinGroupPage-title">
                  Join
                  {' '}
                  {group.getPossessiveSignature()}
                  <br />
                  <strong>
                    <GroupName group={group} />
                  </strong>
                  <Text element="div" color="thunder" size="large">
                    {group.getOrganization() && group.getOrganization().getName()}
                  </Text>
                </DialogTitle>
              </div>
              <JoinGroupFormPanel group={group} />
            </Columns2>
          </BoxBody>
        </Box>
      </CenteredContainer>
    );
  },
});

export default JoinGroupPage;



// WEBPACK FOOTER //
// ./src/join/components/JoinGroupPage.jsx